import { Dialog, type DialogProps } from '@mui/material';

/** Liquid-glass dialog surface — the Dialog counterpart to GlassCard.
 *  Owns the paper styling so a theme tweak is one edit, not one per dialog. */
export function GlassDialog(props: Omit<DialogProps, 'slotProps'>) {
  return (
    <Dialog
      {...props}
      slotProps={{ paper: { sx: (t) => ({
        background: 'rgba(18,24,38,0.85)', backdropFilter: 'blur(18px)',
        ...t.applyStyles('light', { background: 'rgba(255,255,255,0.9)' }),
      }) } }}
    />
  );
}
